import React from "react"
import { useSelectedOrder } from "store/dispatch.redux"
import classNames from "utils/classNames"
import { isToday } from "utils/date-utils"
import { Icon } from "@blueprintjs/core"

const OrderLabel = ({ order: o }) => {
  const [isPresent] = useSelectedOrder(o)
  return (
    <div className="mb-2">
      <div
        className={classNames("font-bold", "vt-warning", {
          "vt-danger": o?.isSelected || isPresent,
          "vt-old-order-text": !isToday(o?.date),
        })}
      >
        {o?.user?.fullName}
        <span className="ml-2">
          <Icon icon="calendar" /> {o?.date}
        </span>
      </div>{" "}
      <div className="text-xs">{o?.trackingCode}</div>
    </div>
  )
}

export default OrderLabel
